<template>
  <div
    class="bg-secondary"
  >
    <div
      class="px-5 pb-5"
    >
      <section
        class="mb-3"
      >
        <label
          class="mb-2 form-label"
          for="articles-section-filter-title-search-input"
        >
          Search By Title
        </label>
        <b-form-input
          id="articles-section-filter-title-search-input"
          class="w-100"
          type="text"
          :value="titleSearch"
          @input="setNewTitleSearch($event)"
          placeholder="Search"
          autocomplete="off"
          data-test="articles-section-filter-title-search-input"
        />
      </section>
      <section
        class="mb-3"
        v-if="!shareMode"
      >
        <label
          class="mb-2 form-label"
          for="articles-section-filter-state-select"
        >
          Filter by State
        </label>
        <b-form-select
          id="articles-section-filter-state-select"
          :options="stateOptions"
          :value="selectedState"
          @change="setNewSelectedState($event)"
          class="w-100"
        >
          <b-form-select-option
            class="d-none"
            :value="null"
            name="State"
            disabled
          >
            Select State
          </b-form-select-option>
        </b-form-select>
      </section>
      <section
        class="mb-4"
      >
        <label
          class="mb-2 form-label"
        >
          Sort
        </label>
        <b-form-select
          id="articles-section-filter-sort-by-dropdown"
          :options="sortOptions"
          :value="selectedSort"
          @change="setNewSelectedSort($event)"
          data-test="articles-section-filter-sort-by-dropdown"
        >
          <b-form-select-option
            class="d-none"
            :value="null"
            name="Sort"
            disabled
          >
            Select
          </b-form-select-option>
        </b-form-select>
      </section>
      <b-button
        variant="primary"
        class="w-100"
        @click="applyFilters()"
        :disabled="!areFiltersApplied"
        data-test="articles-section-apply-filters-button"
      >
        Apply Filters
      </b-button>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import * as contentTypes from '@/modules/content/store/types';

function initialData() {
  return {
    newTitleSearch: null,
    newSelectedState: null,
    newSelectedSort: null,
  };
}
export default {
  name: 'ArticlesFilters',
  props: {
    shareMode: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return initialData();
  },
  computed: {
    ...mapState('content', [
      'contentItemsQueryParams',
    ]),
    stateOptions() {
      return [
        { text: 'Draft', value: 'DRAFT' },
        { text: 'Scheduled', value: 'SCHEDULED' },
        { text: 'Published', value: 'PUBLISHED' },
        { text: 'Paused', value: 'PAUSED' },
      ];
    },
    sortOptions() {
      return [
        { text: 'A-Z', value: 'title,asc' },
        { text: 'Z-A', value: 'title,desc' },
        { text: 'Last Edited', value: 'updatedDate,asc' },
        { text: 'First Edited', value: 'updatedDate,desc' },
      ];
    },
    titleSearch() {
      if (typeof this.newTitleSearch === 'string') return this.newTitleSearch;
      return this.contentItemsQueryParams.search || null;
    },
    selectedState() {
      if (this.newSelectedState) return this.newSelectedState;
      return this.contentItemsQueryParams.states || null;
    },
    selectedSort() {
      if (this.newSelectedSort) return this.newSelectedSort;
      return this.contentItemsQueryParams.sort || null;
    },
    areFiltersApplied() {
      return (this.isValidTitleSearch || this.titleSearch)
        || this.selectedState
        || this.selectedSort;
    },
    isValidTitleSearch() {
      return typeof this.titleSearch === 'string';
    },
  },
  methods: {
    ...mapActions('content', [
      contentTypes.SET_CONTENT_ITEM_QUERY_PARAM,
      contentTypes.SET_SELECTED_ARTICLE_UUID,
      contentTypes.FETCH_SHOWCASE_ARTICLES,
    ]),
    setNewTitleSearch(text) {
      this.newTitleSearch = text;
    },
    setNewSelectedState(state) {
      this.newSelectedState = state;
    },
    setNewSelectedSort(filter) {
      this.newSelectedSort = filter;
    },
    applyFilters() {
      if (!this.areFiltersApplied) return;
      if (this.isValidTitleSearch) this.SET_CONTENT_ITEM_QUERY_PARAM({ search: encodeURIComponent(this.titleSearch) });
      if (this.selectedState) this.SET_CONTENT_ITEM_QUERY_PARAM({ states: this.selectedState });
      if (this.selectedSort) this.SET_CONTENT_ITEM_QUERY_PARAM({ sort: this.selectedSort });
      this.resetData();
      this.FETCH_SHOWCASE_ARTICLES();
    },
    resetData() {
      Object.assign(this.$data, initialData());
      this.SET_SELECTED_ARTICLE_UUID('');
    },
  },
};
</script>
<style lang="scss" scoped>
.sort-by-button {
  display: flex;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1;
  font-size: 1rem;
  .icon-btn {
    font-weight: 400;

  }
  &.selected-sort-button {
    background-color: rgb(200, 223, 231);
    border: 1px solid darkblue;
  }
}
</style>
